export default class Constants {
    static readonly StronglyAgreeGroupName = 'Strongly Agree - Strongly Disagree';

    static readonly TimeOut = '00:00';
}
